const MODEL_IMAGE_BASE_PATH = '/images/models/';
const MODEL_THUMBNAIL_BASE_PATH = '/images/models/thumbs/';
const VALIDATED_PNG_MODEL_THUMBNAILS = new Set([
  'babolat-air-viper-2023.png',
  'babolat-technical-veron-juan-lebron-2025.png',
  'bullpadel-hack-03-comfort-2024.png',
  'head-coello-pro-2025.png',
]);

/**
 * Return the optimized local thumbnail path when a validated thumbnail exists.
 *
 * @param {string} image original model image URL
 * @returns {string} thumbnail URL or the unchanged image URL
 */
export const getModelThumbnailImageSrc = image => {
  if (!image) {
    return image;
  }

  const modelImagePathIndex = image.indexOf(MODEL_IMAGE_BASE_PATH);
  if (modelImagePathIndex < 0) {
    return image;
  }

  const imagePrefix = image.slice(0, modelImagePathIndex);
  const imageName = image.slice(modelImagePathIndex + MODEL_IMAGE_BASE_PATH.length);
  const normalizedImageName = imageName.toLowerCase();
  if (
    normalizedImageName.endsWith('.png') &&
    !VALIDATED_PNG_MODEL_THUMBNAILS.has(normalizedImageName)
  ) {
    return image;
  }

  return imageName && !imageName.includes('/')
    ? `${imagePrefix}${MODEL_THUMBNAIL_BASE_PATH}${imageName}.webp`
    : image;
};
